/**
 * RTE Image Optimizer
 * Adds srcset to description images for responsive loading
 * Note: Lazy loading and basic styling done via Liquid filters
 */

(function() {
  'use strict';

  function addSrcsetToImages() {
    // Find all description images
    const images = document.querySelectorAll('.rte img, .accordion-content img, .faq-answer img, [data-rte-images] img');

    images.forEach(img => {
      // Skip if already processed
      if (img.dataset.srcsetAdded === 'true') return;

      // Skip gallery images
      if (img.closest('.m-product-media, .m-media-gallery, .swiper-slide, .responsive-image, .m-image')) {
        return;
      }

      const src = img.getAttribute('src');

      // Only process Shopify CDN images that don't already have srcset
      if (src && src.includes('cdn.shopify.com') && !img.hasAttribute('srcset')) {
        const baseUrl = src.split('?')[0];

        // Create srcset with multiple sizes
        const srcset = [
          `${baseUrl}?width=375 375w`,
          `${baseUrl}?width=550 550w`,
          `${baseUrl}?width=750 750w`
        ].join(', ');

        img.setAttribute('srcset', srcset);
        img.setAttribute('sizes', '(max-width: 767px) calc(100vw - 40px), (max-width: 1024px) 600px, 750px');
        img.dataset.srcsetAdded = 'true';
      }

      // Ensure lazy loading
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      // Ensure responsive styling
      if (!img.style.maxWidth) {
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(addSrcsetToImages, 100);
    });
  } else {
    setTimeout(addSrcsetToImages, 100);
  }

  // Run when accordion is opened (for hidden content)
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.accordion-header, .faq-question');
    if (trigger) {
      setTimeout(addSrcsetToImages, 200);
    }
  });
})();